import { reactive } from 'vue'

export const state = reactive({
  items: []
})

function addToast(type, message, title, duration = 5000) {
  const id = Date.now() + Math.random()
  state.items.push({ id, type, message, title, duration })
}

function handleToast(type, arg1, arg2, arg3) {
  let message, title, duration

  if (typeof arg2 === 'string') {
    title = arg1; message = arg2; duration = typeof arg3 === 'number' ? arg3 : 5000
  } else if (typeof arg2 === 'number') {
    message = arg1; title = undefined; duration = arg2
  } else {
    message = arg1; title = undefined; duration = 5000
  }
  addToast(type, message, title, duration)
}

export const toast2 = {
  success: (a, b, c) => handleToast('success', a, b, c),
  error: (a, b, c) => handleToast('error', a, b, c),
  warning: (a, b, c) => handleToast('warning', a, b, c),
  info: (a, b, c) => handleToast('info', a, b, c),
  primary: (a, b, c) => handleToast('primary', a, b, c),
  default: (a, b, c) => handleToast('default', a, b, c)
}

export function removeToast(id) {
  const index = state.items.findIndex(t => t.id === id)
  if (index > -1) state.items.splice(index, 1)
}
